import Styles from './Spinner.module.scss'

export const Spinner = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={Styles.spinner}
  >
    <mask id="path-1-inside-1_5242_390" fill="white">
      <path d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z" />
    </mask>
    <g
      clipPath="url(#paint0_angular_5242_390_clip_path)"
      data-figma-skip-parse="true"
      mask="url(#path-1-inside-1_5242_390)"
    >
      <g transform="matrix(0 -0.008 0.008 0 10 10)">
        <foreignObject x="-1375" y="-1375" width="2750" height="2750">
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore - foreignObject requires XHTML namespace for HTML children */}
          <div
            style={{
              background: 'conic-gradient(from 90deg,rgba(255, 255, 255, 0.1) 0deg,rgba(0, 0, 0, 0.6) 360deg)',
              height: '100%',
              width: '100%',
              opacity: 1,
            }}
          ></div>
        </foreignObject>
      </g>
    </g>
    <path
      d="M18 10H15C15 12.7614 12.7614 15 10 15V18V21C16.0751 21 21 16.0751 21 10H18ZM10 18V15C7.23858 15 5 12.7614 5 10H2H-1C-1 16.0751 3.92487 21 10 21V18ZM2 10H5C5 7.23858 7.23858 5 10 5V2V-1C3.92487 -1 -1 3.92487 -1 10H2ZM10 2V5C12.7614 5 15 7.23858 15 10H18H21C21 3.92487 16.0751 -1 10 -1V2Z"
      mask="url(#path-1-inside-1_5242_390)"
    />
    <defs>
      <clipPath id="paint0_angular_5242_390_clip_path">
        <path
          d="M18 10H15C15 12.7614 12.7614 15 10 15V18V21C16.0751 21 21 16.0751 21 10H18ZM10 18V15C7.23858 15 5 12.7614 5 10H2H-1C-1 16.0751 3.92487 21 10 21V18ZM2 10H5C5 7.23858 7.23858 5 10 5V2V-1C3.92487 -1 -1 3.92487 -1 10H2ZM10 2V5C12.7614 5 15 7.23858 15 10H18H21C21 3.92487 16.0751 -1 10 -1V2Z"
          mask="url(#path-1-inside-1_5242_390)"
        />
      </clipPath>
    </defs>
  </svg>
)

